<template>
  <div class="bgLight flex-touch">
    <div class="container">
      <img
        width="30"
        src="../assets/img/illustrations/bulp.png"
        class="bulp-illustration"
      />
      <SectionHeader
        class="section-header"
        title="Návod na pera FlexTouch<sup>®</sup>"
      />
      <div style="padding: 56.25% 0 0 0; position: relative" class="mb-12">
        <iframe
          src="https://player.vimeo.com/video/1033415045?h=5d20e17ace&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
          title="Videonávod pro Flextouch"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader.vue";

export default {
  components: { SectionHeader },
};
</script>

<style lang="scss" scoped>
.flex-touch {
  position: relative;
  background: var(--v-primary-base);
  height: 100%;
  padding-top: 5rem;
  &__background {
    background: var(--v-bgLight-base);
    height: 40rem;
    width: 100%;
    position: absolute;
    left: 0;
    top: -5rem;
  }

  .bulp-illustration {
    position: absolute;
    left: 50%;
    top: -3rem;
    transform: translate(-50%);
  }
}
</style>
